export const ACTUALIZAR_DEPOSITOS = "ACTUALIZAR_DEPOSITOS";
export const ACTUALIZAR_SECTORES = "ACTUALIZAR_SECTORES";
export const ACTUALIZAR_DEPOSITOS_DB = "ACTUALIZAR_DEPOSITOS_DB";
export const CARGANDO_DEPOSITOS = "CARGANDO_DEPOSITOS";
export const ERROR_DEPOSITOS = "ERROR_DEPOSITOS";
export const LIMPIAR_ERROR = "LIMPIAR_ERROR";
